export default __webpack_public_path__ + "img/662abbf671570803d0612d10c58c95f3.svg";